module.exports = __webpack_public_path__ + "static/media/ic_action24px_json.e11ed111.svg";